/**
 * External MIDI instrument — silent Adam slot that emits Web MIDI during playback.
 */
import type { ExternalMidiPatch, Instrument } from "../types";

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function createDefaultExternalMidiPatch(): ExternalMidiPatch {
  return {
    outputDeviceId: "",
    channel: 1,
  };
}

export function normalizeExternalMidiPatch(
  raw?: Partial<ExternalMidiPatch> | null,
): ExternalMidiPatch {
  const channel = Number(raw?.channel ?? 1);
  return {
    outputDeviceId:
      typeof raw?.outputDeviceId === "string" ? raw.outputDeviceId.trim() : "",
    channel: clamp(Number.isFinite(channel) ? Math.round(channel) : 1, 1, 16),
  };
}

export function externalMidiInstrument(
  patch?: Partial<ExternalMidiPatch> | null,
): Instrument {
  return {
    kind: "externalMidi",
    patch: normalizeExternalMidiPatch(patch),
  };
}

export function isExternalMidiInstrument(
  instrument: Instrument | null | undefined,
): instrument is Extract<Instrument, { kind: "externalMidi" }> {
  return instrument?.kind === "externalMidi";
}

export function cloneExternalMidiPatch(patch: ExternalMidiPatch): ExternalMidiPatch {
  return normalizeExternalMidiPatch(patch);
}
